module.exports = __webpack_public_path__ + "static/media/germany-icon.7e6e4d9b.svg";